import { Component } from '@theme/component';
import FlipDown from './flipdowns.js';

/**
 * A custom element that displays a FlipDown countdown clock.
 *
 * @extends {Component}
 */
class Countdown extends Component {
  connectedCallback() {
    // Fire parent setup if it exists in your theme's base Component
    if (super.connectedCallback) {
      super.connectedCallback();
    }

    // Set the target date (e.g., Sept 24, 2026, at 09:00:00)
    // FlipDown expects a Unix timestamp in SECONDS, so we divide by 1000
    const targetDate = new Date('2026-09-24T09:00:00').getTime() / 1000;

    try {
      // Initialize the clock. 
      // FlipDown needs the target Unix timestamp, the ID of the HTML element, and options.
      const flipdown = new FlipDown(targetDate, this.id, {
        theme: 'light', // FlipDown supports 'dark' or 'light'
      }).start();

      // Optional: What happens when the timer hits zero?
      flipdown.ifEnded(() => {
        console.log('Registration is now live!');
        // You could trigger a DOM update here to replace the clock with a "Register Now" button
      });

    } catch (error) {
      console.error('Failed to initialize FlipDown:', error);
    }
  }
}

// Register the custom element
customElements.define('count-down', Countdown);